import moment from "moment";
import packApi from "../api/pack";

const actions = {
  async getList({ commit }) {
    const packList = await packApi.list();

    return commit("setPackList", packList);
  },

  async getPack({ commit }, params) {
    const packId = params.id;
    const packResults = await packApi.get(packId);
    const pack = packResults.data;

    return commit("setPack", pack);
  },

  async getPackTotals({ commit }, params) {
    const { packId } = params;
    const { serviceAreaId } = params;
    const packTotals = await packApi.getPackTotals(packId, serviceAreaId);
    return commit("setPackTotals", packTotals.data.result);
  },
  async getPackBreakdown({ commit }, params) {
    let packBreakdown = {};
    const { packId } = params;
    const { serviceAreaId } = params;
    const packBreakdownByBuildType = await packApi.getPackBreakdown(packId, serviceAreaId, "buildType");
    const packBreakdownByApplication = await packApi.getPackBreakdown(packId, serviceAreaId, "application");
    const packBreakdownByOperationalizeType = await packApi.getPackBreakdown(
      packId,
      serviceAreaId,
      "operationalizeType"
    );
    const packBreakdownByReleaseType = await packApi.getPackBreakdown(packId, serviceAreaId, "releaseType");
    const packBreakdownByUserRole = await packApi.getPackBreakdown(packId, serviceAreaId, "userRole");

    packBreakdown = {
      buildType: packBreakdownByBuildType.data.result,
      application: packBreakdownByApplication.data.result,
      operationalizeType: packBreakdownByOperationalizeType.data.result,
      releaseType: packBreakdownByReleaseType.data.result,
      userRole: packBreakdownByUserRole.data.result,
    };
    return commit("setPackBreakdown", packBreakdown);
  },

  async getStatusByAssignee({ commit }, params) {
    const { packId } = params;
    const { serviceAreaId } = params;
    const packStatusByAssignee = await packApi.getStatusByAssignee(packId, serviceAreaId);
    return commit("setStatusByAssignee", packStatusByAssignee.data.result);
  },

  async setEditPack({ commit }, packId) {
    const pack = await packApi.get(packId);
    commit("setPackRecord", pack.data);
    commit("setPack", pack.data);
  },

  async update({ commit, state }) {
    await packApi.put(state.packRecord);
    const newPack = await packApi.get(state.packRecord.id);
    commit("setPack", newPack.data);
    commit("resetPackRecord");
  },

  async create({ commit, state }) {
    const newPack = await packApi.post(state.packRecord);
    commit("setPack", newPack.data);
    commit("resetPackRecord");
  },

  async remove({ dispatch }, data) {
    await packApi.remove(data);
    await dispatch("getList");
    return true;
  },

  async resetPackRecord({ commit }) {
    commit("resetPackRecord");
  },
};

const mutations = {
  setUatOpen(state, isUatOpen) {
    state.isUatOpen = isUatOpen;
  },
  resetPackRecord(state) {
    state.packRecord = {};
  },
  setPackRecord(state, pack) {
    state.packRecord = Object.assign({}, pack);
  },
  setPack(state, pack) {
    state.pack = pack;
  },
  setPackBreakdown(state, packBreakdown) {
    state.packBreakdown = packBreakdown;
  },
  setPackList(state, packs) {
    state.packList = packs;
  },
  setPackListWithReleaseNotes(state, packListWithReleaseNotes) {
    state.packListWithReleaseNotes = packListWithReleaseNotes;
  },
  setPilotParticipationList(state, pilotParticipationList) {
    state.packRecord.pilotParticipationList = pilotParticipationList;
  },
  setPackTotals(state, packTotals) {
    state.packTotals = packTotals;
  },
  setStatusByAssignee(state, packStatusByAssignee) {
    state.statusByAssignee = packStatusByAssignee;
  },
  setPendingDrillThrough(state, pending) {
    state.pendingDrillThrough = pending;
  },
  clearPendingDrillThrough(state) {
    state.pendingDrillThrough = null;
  },
};

const state = {
  packBreakdown: {},
  packRecord: {},
  pack: {},
  packList: [],
  packTotals: {},
  statusByAssignee: {},
  pendingDrillThrough: null,
};

const getters = {
  getActivePackList: state => {
    return state.packList.filter(pack => pack.status != "Available in PRD");
  },
  getById: state => id => {
    return state.packList.find(item => {
      return item.id === id;
    });
  },
  isUatOpen: state => {
    const uatStartTimestampInMilli = moment.utc(state.pack.uatStart).format("x");
    const todayTimeStampInMilli = Date.now();
    return todayTimeStampInMilli >= uatStartTimestampInMilli;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
